import {memo, useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {fetchDataDS} from "../../../redux/darkstoreReducer";
import {selectGlob} from "../../../common/selectors";
import {formatWeekToArray} from "../../../common/formatWeekToISODate";
import {SizeIndicators} from "./SizeIndicators";
import {RegionsIndicators} from "./regionsIndicators";
import {BigStoreIndicators} from "./bigStoreIndicators";
import styles from './globalIndicators.module.sass'
import {Card} from "antd";

type GlobalIndicatorsPropsType = {
    week: string
}

export const GlobalIndicators = memo(({week}: GlobalIndicatorsPropsType) => {

    const dispatch = useAppDispatch()

    const data = useAppSelector(selectGlob)

    const date = formatWeekToArray(week)

    useEffect(() => {
        dispatch(fetchDataDS({city: '', end_date_to: date[1], start_date_from: date[0], offset: 0, type: 'global'}))
    }, [week]);

    return (
        <>
            {data && <div className={styles.cards}>
                <Card className={styles.card}><SizeIndicators data={data}/></Card>
                <Card className={styles.card}><RegionsIndicators data={data}/></Card>
                <Card className={styles.card}><BigStoreIndicators data={data}/></Card>
            </div>}
        </>

    );
});
